import styled from "styled-components";

export const BodyModal = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    display: flex;
    gap: 20px;
    padding-bottom: 5px;
  }

  .item {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    label {
    }
    .val {
    }
  }
`;

export const Container = styled.div`
  canvas#InterestByLocation {
     overflow: visible !important;
    z-index: 9999999;
  }
  padding: 20px;
  display: flex;
  align-items: center;
  height: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  min-height: 280px;
  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    display: flex;
    gap: 20px;
    width: 100%;
  }

  .no-result {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
  .wraper {
    flex: 1;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    &-left {
      width: 120px;
      height: 120px;
    }

    &-right {
      padding: 20px;
      display: flex;
      align-items: start;
      gap: 10px;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      min-width: 220px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 15px;
        .left {
          display: flex;
          align-items: center;
          gap: 3px;
        }
      }
    }
  }
`;
